import { AppState } from '../AppTypes';

export const _hasFlags = (state: AppState) => {
  return (flags: string[]) => {
    if (!flags || flags.length === 0) {
      //If required flags is empty then we aren't asking for any flags to be
      //present so return true.
      return true;
    }
    return flags.every(f => state?.flags?.includes(f));
  };
};
